import { OffersActionTypes } from "./constants";

export interface OfferActionType {
  type:
    | OffersActionTypes.API_RESPONSE_SUCCESS
    | OffersActionTypes.API_RESPONSE_ERROR
    | OffersActionTypes.GET_OFFERS
    | OffersActionTypes.UPDATE_OFFERS
    | OffersActionTypes.DELETE_OFFERS
    | OffersActionTypes.ADD_OFFERS
    | OffersActionTypes.CLEAR_ERROR;

  payload: any;
}

// common success
export const OffersApiResponseSuccess = (actionType: string, data: any | {}): OfferActionType => ({
  type: OffersActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// common error
export const OffersApiResponseError = (actionType: string, error: string): OfferActionType => ({
  type: OffersActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// get offers
export const getOffersAction = (): OfferActionType => ({
  type: OffersActionTypes.GET_OFFERS,
  payload: {},
});

export const deleteOffersAction = (id: string): OfferActionType => ({
  type: OffersActionTypes.DELETE_OFFERS,
  payload: { id },
});

export const updateOffersAction = (
  id: string,
  description: string,
  order?: number,
  status?: string
): OfferActionType => ({
  type: OffersActionTypes.UPDATE_OFFERS,
  payload: { id, description, order, status },
});

// add offer
export const addOffersAction = (
  description: string,
  order?: number,
  status?: string
): OfferActionType => ({
  type: OffersActionTypes.ADD_OFFERS,
  payload: { description, order, status },
});

// clear error
export const clearOffersError = (): OfferActionType => ({
  type: OffersActionTypes.CLEAR_ERROR,
  payload: {},
});
